/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { Component, Inject, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogRef } from '../../../aero/aero-dialog/types';
// eslint-disable-next-line import/no-cycle
import { AccountSettingsDialogService } from '../account-settings-dialog.service';

/**
 * Angular component that show dialog for add child/student.
 */
@Component({
  selector: 'bulb-add-student-dialog',
  templateUrl: './add-student-dialog.component.html',
  styleUrls: ['./add-student-dialog.component.scss'],
  standalone: false,
})
export class AddStudentDialogComponent implements OnInit {

  /**
   * Username of the student.
   */
  username: string;

  /**
   * Holds value of student code.
   */
  studentCode: string;

  /**
   * True if server returns error.
   */
  addStudentError = false;

  /**
   * Constructor.
   *
   * @param dialogRef
   * @param config
   * @param dialogService
   */
  constructor(
    @Inject('DialogRef') private dialogRef:DialogRef,
    public config: DynamicDialogConfig,
    private dialogService: AccountSettingsDialogService,
  ) { }

  ngOnInit(): void {
    this.dialogRef.setPrimaryDisabled(true);
    this.showError();
  }

  /**
   * Call on change of fields.
   * @param event
   */
  onValueChange(event) {
    this.dialogRef.setPrimaryDisabled(!(this.username && this.studentCode));
    this.config.data.valueChange({ username: this.username, studentCode: this.studentCode });
    this.addStudentError = false;
  }

  /**
   * Show error if server respond with error.
   */
  showError() {
    this.dialogService.serviceSubject.subscribe((data: any) => {
      if (data.error) {
        this.addStudentError = data.error;
      }
      if (data.close) {
        this.dialogRef.close();
      }
    });
  }
}
